<template>
  <div v-if="PopupDatiAssistenza" class="overlay" @click.self="close">
    <div class="box">
      <img src="@/assets/images/LogoDMS.png" alt="Logo" class="logo" />
      <div class="text">
       <div class="title-group">
        <p class="title">DMS EW WEB</p>
        <p class="subtitle">C.S.G. S.r.l. 2007–2025. All rights reserved.</p>
       </div>

        <div class="group">
          <p>C.S.G. Centro Servizi di Geoingegneria S.r.l.</p>
          <p>Via Francesco Cazzulini 15/A</p>
          <p>15010 Ricaldone (AL) – ITALIA</p>
        </div>

        <p class="web">Web: <a href="https://www.csgsrl.eu" target="_blank">www.csgsrl.eu</a></p>

        <p class="support">
          {{ this.GetTraduzioneLabel('VUEPopupDatiAssistenza','TKN_POPUP_DATI_ASSISTENZA',this.LinguaUtente) }}  
          <a href="mailto:tecnico@csgsrl.eu">tecnico@csgsrl.eu</a>
          {{ this.GetTraduzioneLabel('VUEPopupDatiAssistenza','TKN_LETT_O',this.LinguaUtente) }} +39 0144 74277
        </p>
      </div>
    </div>
  </div>
</template>

<script>

import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { SystemInformation } from '@/SystemInformation';

export default {
  mixins: [ MixInsGestioneTraduzioni ],
  data()
  {
   return {
            LinguaUtente : SystemInformation.UserInformation.Lingua
   }
  },
  props: ['PopupDatiAssistenza'],
  emits: ['OnClickChiudiPopup'],
  methods: 
  {
    close() 
    { 
      this.$emit('OnClickChiudiPopup'); 
    }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed; 
  inset: 0; 
  background: rgba(0,0,0,0.5);
  display: flex; 
  align-items: center; 
  justify-content: center; 
  z-index: 9999;
}

.box {
  background: #fff; 
  border: 4px solid #F18B53;
  padding: 2rem; 
  min-height: auto;
  width: 600px; 
  max-width: 90vw; 
  text-align: center;
  box-shadow: 0 0 10px rgba(0,0,0,0.3);
}

.logo { 
  width: 250px; 
  margin-bottom: 2rem; 
 }

.text { 
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  font-weight: 520;
  font-size: 14px; 
  color: #333; 
  line-height: 1.3; 
  }

.title-group {
  display: flex;
  flex-direction: column;
  gap: 0rem;
}
 
.text p {
  margin: 0.25rem 0;
}

.text .title {
  font-weight: 700;          
  font-size: 19px;
}

.text .subtitle {
  font-size: 10px;           
  margin-bottom: 3rem;       
}

.text .group {
  margin-bottom: 1rem;
}

.text .web {
  margin: 1rem 0;
}

.text .support {
  margin-top: 1rem;
}

.text a {
  color: #0000EE;
  text-decoration: underline;
}
</style>